import React from "react";

export const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="178" height="20" fill="none">
    <path
      fill="#fff"
      d="M65.416 19.246c-.992 0-1.848-.262-2.566-.785-.711-.523-1.258-1.258-1.641-2.203-.375-.953-.563-2.063-.563-3.328v-.246c0-1.32.192-2.473.575-3.457.383-.993.926-1.762 1.629-2.309.71-.555 1.55-.832 2.52-.832.671 0 1.25.14 1.733.422.493.273.922.66 1.29 1.16v-4.16l-1.782-.375V.719h5.895v15.504l1.476.375V19h-5.039l-.304-1.57c-.383.593-.836 1.047-1.36 1.36-.523.304-1.144.456-1.863.456zm1.277-3.152c.344 0 .664-.067.961-.2a1.83 1.83 0 00.739-.597v-5.074a2.021 2.021 0 00-.727-.727 1.784 1.784 0 00-.95-.258c-.468 0-.847.145-1.136.434-.289.289-.5.691-.633 1.207-.125.516-.187 1.117-.187 1.805v.246c0 1.008.14 1.789.422 2.343.28.547.785.82 1.511.82zM35.32 19.32c-1.313 0-2.344-.414-3.094-1.242-.75-.828-1.125-2.11-1.125-3.844v-5.05l-1.36-.375V6.395h5.473v7.863c0 .625.129 1.101.387 1.43.265.32.66.48 1.183.48.305 0 .606-.055.903-.164.304-.117.574-.29.808-.516V9.184l-1.383-.375V6.395h5.496v9.902l1.582.375v2.402h-5.156l-.27-1.441a4.091 4.091 0 01-1.488 1.254c-.578.289-1.23.433-1.957.433zM45.502 19.074v-2.402l1.477-.375V9.184l-1.758-.375V6.395h5.649l.14 1.77a4.64 4.64 0 011.547-1.477c.617-.352 1.317-.528 2.098-.528 1.187 0 2.125.402 2.812 1.207.688.805 1.032 2.082 1.032 3.832v5.098l1.476.375v2.402h-6.797v-2.402l1.196-.375v-5.11c0-.68-.137-1.16-.41-1.44-.274-.29-.665-.434-1.172-.434-.383 0-.711.07-.985.21a1.954 1.954 0 00-.715.61v6.164l1.055.375v2.402h-6.645zM23.2 19.16c-1.305 0-2.423-.27-3.352-.808a5.466 5.466 0 01-2.121-2.274c-.485-.976-.727-2.105-.727-3.387v-.234c0-1.266.242-2.383.727-3.352a5.466 5.466 0 012.12-2.273C20.77 6.277 21.88 6 23.177 6c1.305 0 2.414.273 3.328.82a5.39 5.39 0 012.11 2.274c.491.969.738 2.09.738 3.363v.234c0 1.274-.247 2.399-.739 3.375a5.39 5.39 0 01-2.11 2.274c-.913.547-2.015.82-3.304.82zm0-3.129c.5 0 .898-.133 1.195-.398.304-.274.523-.66.656-1.16.14-.5.21-1.094.21-1.782v-.234c0-.664-.07-1.242-.21-1.734-.133-.5-.352-.887-.656-1.16-.305-.282-.711-.422-1.22-.422-.5 0-.902.14-1.206.421-.305.274-.524.66-.657 1.16-.132.493-.199 1.071-.199 1.735v.234c0 .696.067 1.293.2 1.793.132.5.351.883.656 1.149.304.265.715.398 1.23.398zM0 19.074v-2.402l1.77-.375V4.8L0 4.426V2h8.39c1.352 0 2.524.215 3.516.645.992.43 1.758 1.042 2.297 1.84.54.788.809 1.726.809 2.812 0 1-.274 1.93-.82 2.789-.54.86-1.282 1.55-2.227 2.074-.945.516-2.024.77-3.235.762l-2.847-.035v3.41l1.77.375v2.402H0zm10.805 0l-2.297-6.656 3.574-1.219 2.074 5.074 1.617.41v2.391h-4.968zm-4.922-9.34h2.554c.797 0 1.41-.183 1.84-.55.43-.375.645-.914.645-1.618 0-.726-.219-1.308-.656-1.746-.438-.445-1.063-.668-1.875-.668H5.883v4.582zM104.312 19.246c-.757 0-1.398-.148-1.921-.445-.516-.305-.953-.742-1.313-1.313L100.809 19h-3.551V3.508L95.5 3.133V.719h5.859v6.855a3.56 3.56 0 011.266-1.101c.508-.258 1.094-.387 1.758-.387 1.008 0 1.859.27 2.555.809.703.539 1.234 1.304 1.593 2.296.367.985.551 2.149.551 3.493v.246c0 1.28-.184 2.398-.551 3.351-.359.946-.894 1.676-1.605 2.192-.703.515-1.574.773-2.614.773zM103 16.094c.742 0 1.258-.262 1.547-.785.297-.524.445-1.317.445-2.38v-.245c0-.735-.066-1.356-.199-1.864-.125-.515-.328-.906-.609-1.172-.282-.273-.657-.41-1.125-.41-.383 0-.723.09-1.02.27a1.88 1.88 0 00-.68.738v5.098c.203.265.442.457.715.574.281.117.59.176.926.176zM110.511 19v-2.402l1.5-.375V3.508l-1.781-.375V.719h5.895v15.504l1.488.375V19h-7.102zM124.913 19.246c-1.242 0-2.328-.265-3.258-.797a5.727 5.727 0 01-2.156-2.203c-.508-.93-.762-1.98-.762-3.152v-.434c0-1.289.227-2.43.68-3.422.453-.992 1.117-1.765 1.992-2.32.875-.563 1.949-.84 3.223-.832 1.148 0 2.117.223 2.906.668.797.437 1.402 1.086 1.817 1.945.414.852.621 1.903.621 3.153v2.12h-6.973l-.012.083c.063.398.196.754.399 1.066.211.305.5.547.867.727.367.18.82.27 1.359.27.532 0 1.051-.06 1.559-.177a8.818 8.818 0 001.629-.586l.937 2.485c-.57.406-1.265.742-2.086 1.008-.82.265-1.734.398-2.742.398zm-1.91-7.816h3.223v-.305c0-.453-.047-.832-.141-1.137-.086-.304-.238-.535-.457-.691-.219-.156-.52-.235-.902-.235-.414 0-.746.102-.996.305-.243.195-.422.469-.54.82a6.023 6.023 0 00-.234 1.184l.047.059zM136.215 19.125c-1 0-1.934-.09-2.801-.27a11.343 11.343 0 01-2.332-.761l-.047-3.95h2.777l.469 1.84c.164.102.375.192.633.27.258.07.566.105.926.105.664 0 1.121-.09 1.371-.27.25-.179.375-.405.375-.679 0-.265-.145-.508-.434-.726-.281-.227-.886-.426-1.816-.598-1.484-.29-2.578-.781-3.281-1.477-.703-.703-1.055-1.578-1.055-2.625 0-.71.164-1.367.492-1.968.328-.602.863-1.086 1.606-1.454.75-.375 1.75-.562 3-.562.953 0 1.859.082 2.718.246.868.164 1.579.371 2.133.621l-.011 3.82h-2.766l-.352-1.64a1.965 1.965 0 00-.609-.281 2.87 2.87 0 00-.762-.094c-.523 0-.906.094-1.148.281a.878.878 0 00-.363.727c0 .172.05.343.152.515.109.172.32.336.633.492.312.157.769.301 1.371.434 1.445.32 2.531.766 3.258 1.336.734.57 1.101 1.438 1.101 2.602 0 1.25-.449 2.242-1.348 2.976-.89.727-2.187 1.09-3.89 1.09zM79.648 19.078c-1.328 0-2.34-.351-3.035-1.055-.687-.71-1.031-1.832-1.031-3.363V8.965H74V6.129h1.582V3h4.09v3.129h2.074v2.836h-2.074v5.683c0 .415.094.704.281.868.188.164.445.246.774.246.14 0 .28-.008.421-.024.141-.015.282-.035.422-.058l.282 3.07c-.36.102-.723.18-1.09.234-.36.063-.73.094-1.114.094zM87.66 19.16c-1.226 0-2.226-.348-3-1.043-.773-.695-1.16-1.62-1.16-2.777 0-.79.21-1.488.633-2.098.43-.61 1.07-1.086 1.922-1.43.86-.351 1.933-.527 3.222-.527h1.325v-.75c0-.508-.145-.937-.434-1.289-.29-.36-.746-.539-1.371-.539-.266 0-.516.035-.75.105a2.134 2.134 0 00-.621.282l-.282 1.617H84.25l-.059-3.527a18.78 18.78 0 012.25-.832C87.231 6.117 88.11 6 89.078 6c1.727 0 3.098.398 4.113 1.195 1.016.79 1.524 1.918 1.524 3.387v5.203c.008.172.027.336.058.492l1.371.235v2.402H91.34a4.17 4.17 0 01-.328-.562 2.8 2.8 0 01-.246-.704 4.415 4.415 0 01-1.29 1.114c-.476.265-1.082.398-1.816.398zm1.266-2.906c.297 0 .593-.059.89-.176.305-.125.567-.308.786-.55v-1.829h-1.278c-.555 0-.984.121-1.289.364a1.179 1.179 0 00-.445.96c0 .383.125.684.375.903.25.219.57.328.96.328z"
    />
    <path
      fill="#E3BA27"
      fillRule="evenodd"
      d="M150.297 5.281a2 2 0 00-2 2v8a2 2 0 002 2h25a2 2 0 002-2v-8a2 2 0 00-2-2h-25zm20.293 7.64l.414 1.36h1.305l-2.024-5.734h-1.48l-2.016 5.734h1.305l.414-1.36h2.082zm-.938-3.105l.649 2.09h-1.489c.407-1.315.653-2.14.739-2.472.021.093.054.221.101.382zM154.793 8.57h-1.777v5.711h2.136c.646 0 1.157-.146 1.532-.437.377-.292.566-.698.566-1.219 0-.367-.081-.662-.242-.883-.159-.221-.419-.372-.781-.453v-.039a.953.953 0 00.636-.395c.162-.218.242-.498.242-.84 0-.502-.183-.868-.55-1.097-.365-.232-.952-.348-1.762-.348zm.137 2.262h-.703v-1.27h.636c.347 0 .599.049.758.145.162.094.242.25.242.469 0 .234-.074.402-.222.504-.146.101-.383.152-.711.152zm-.703 2.45v-1.489h.75c.677 0 1.015.237 1.015.71 0 .264-.079.46-.238.587-.159.127-.405.191-.738.191h-.789zm4.164 1h3.289v-1h-2.078v-1.473h1.933v-.993h-1.933V9.562h2.078V8.57h-3.289v5.711zm6.687 0h-1.211V9.577h-1.551V8.57h4.313v1.008h-1.551v4.703z"
      clipRule="evenodd"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      d="M15.293 17.707a1 1 0 011.414-1.414l4 4a1 1 0 01-1.414 1.414l-4-4z"
      opacity=".5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 11a8 8 0 1016 0 8 8 0 00-16 0zm13.714 0a5.714 5.714 0 11-11.428 0 5.714 5.714 0 0111.428 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CollapseMenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="13" height="14" x="9" y="5" fill="#fff" opacity=".3" rx="1" />
    <rect width="5" height="14" x="2" y="5" fill="#fff" rx="1" />
  </svg>
);

export const MessageIcon: React.FC<{}> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13">
    <g fill="none">
      <path d="M-3-6h24v24H-3z" />
      <path
        fill="currentColor"
        d="M2 0h14a2 2 0 012 2v9a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm13.144 1.84L9 5.148 2.856 1.84a.75.75 0 10-.712 1.32l6.5 3.5c.222.12.49.12.712 0l6.5-3.5a.75.75 0 00-.712-1.32z"
      />
    </g>
  </svg>
);

export const PeopleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18">
    <g fill="none">
      <path d="M0-3h24v24H0z" />
      <path
        fill="currentColor"
        d="M18 11a3 3 0 110-6 3 3 0 010 6zM9 8a4 4 0 110-8 4 4 0 010 8z"
        opacity=".5"
      />
      <path
        fill="currentColor"
        d="M17.601 12c3.407.038 6.188 1.76 6.397 5.4.009.147 0 .6-.542.6H19.6c0-2.25-.744-4.328-1.999-6zm-17.6 5.2C.388 12.426 4.26 10 8.983 10c4.788 0 8.722 2.293 9.015 7.2.012.195 0 .8-.751.8H.727c-.25 0-.747-.54-.726-.8z"
      />
    </g>
  </svg>
);

export const TagIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.967 17.473L.523 11.029a1.798 1.798 0 010-2.535L8.613.541c.336-.33.789-.516 1.26-.516h6.454c.993 0 1.798.805 1.798 1.797v6.436c0 .483-.194.945-.538 1.283L9.51 17.473a1.797 1.797 0 01-2.543 0zm8.761-13.254a1.797 1.797 0 11-3.595 0 1.797 1.797 0 013.595 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 7a1 1 0 10-2 0v4H8a1 1 0 100 2h4v4a1 1 0 102 0v-4h4a1 1 0 100-2h-4V7z"
      clipRule="evenodd"
    />
  </svg>
);
export const MenuIcon = () => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2h10v2H7V2zM7 11h10v2H7v-2zM11 20h6v2h-6v-2z"
      fill="#161630"
    />
  </svg>
);

export const XIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect
      width="16"
      height="2"
      x="5.636"
      y="16.95"
      fill="#000"
      rx="1"
      transform="rotate(-45 5.636 16.95)"
    />
    <rect
      width="16"
      height="2"
      x="7.05"
      y="5.636"
      fill="#000"
      opacity=".3"
      rx="1"
      transform="rotate(45 7.05 5.636)"
    />
  </svg>
);

export const EditIcon = () => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.925 6.318a1.5 1.5 0 010 2.121l-8.449 8.449a1.5 1.5 0 01-1.075.44l-3.523-.035a1.5 1.5 0 01-1.485-1.463l-.086-3.427a1.5 1.5 0 01.439-1.098l8.522-8.522a1.5 1.5 0 012.121 0l3.536 3.535z"
      fill="currentColor"
    />
    <rect
      opacity=".5"
      x="5"
      y="20"
      width="15"
      height="2"
      rx="1"
      fill="currentColor"
    />
  </svg>
);
export const DeleteIcon = () => (
  <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 8.5V21a1.5 1.5 0 001.5 1.5h9A1.5 1.5 0 0018 21V8.5H6z"
      fill="currentColor"
    />
    <path
      opacity=".5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 5v-.5a1 1 0 00-1-1h-2a1 1 0 00-1 1V5H5.5a.5.5 0 00-.5.5V6a.5.5 0 00.5.5h13A.5.5 0 0019 6v-.5a.5.5 0 00-.5-.5H14z"
      fill="currentColor"
    />
  </svg>
);

export const SaveIcon = () => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4.5h1v7h10v-7l2.854 2.854a.5.5 0 01.146.353V18.5c0 1.3-.8 2-2 2H6c-1.209 0-2-.7-2-2v-12c0-1.3.791-2 2-2z"
      fill="currentColor"
    />
    <rect
      opacity=".5"
      x="12"
      y="4.5"
      width="3"
      height="5"
      rx=".5"
      fill="currentColor"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      d="M7.287 12.587H9.24v8.123c0 .077.03.15.085.205a.286.286 0 00.203.085h3.311c.076 0 .15-.03.203-.085a.292.292 0 00.085-.205v-8.085h2.245a.291.291 0 00.285-.257l.341-2.99a.29.29 0 00-.285-.324h-2.586V7.179c0-.565.3-.851.895-.851h1.69c.077 0 .15-.03.204-.085A.292.292 0 0016 6.037V3.292c0-.077-.03-.15-.084-.205a.286.286 0 00-.203-.085h-2.33A2.277 2.277 0 0013.275 3c-.405 0-1.81.08-2.92 1.112-1.23 1.143-1.06 2.512-1.018 2.75v2.192h-2.05c-.077 0-.15.03-.204.085A.292.292 0 007 9.344v2.952a.292.292 0 00.177.269.285.285 0 00.11.022z"
    />
  </svg>
);

export const GoogleIcon = () => (
  <svg width="23" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.733 9.818H11.767v4.636h6.312c-.588 2.946-3.049 4.637-6.312 4.637-3.85 0-6.953-3.164-6.953-7.091s3.102-7.09 6.953-7.09c1.659 0 3.156.6 4.333 1.58L19.523 3c-2.086-1.855-4.76-3-7.756-3C5.242 0 0 5.345 0 12c0 6.654 5.242 12 11.767 12C17.651 24 23 19.636 23 12c0-.71-.107-1.473-.267-2.182z"
      fill="currentColor"
    />
  </svg>
);

export const SendIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="none">
    <path
      fill="currentColor"
      d="M6.095 19.027C3.43 20.665 0 18.747 0 15.619V4.381C0 1.252 3.43-.665 6.095.973l9.141 5.62c2.54 1.56 2.54 5.253 0 6.815l-9.141 5.619z"
    />
    <path fill="#fff" d="M0 8v4l14-2L0 8z" opacity=".44" />
  </svg>
);

export const NotificationsIcons = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      d="M20 10.792A5.5 5.5 0 0113.207 4H6.25a2.25 2.25 0 00-2.25 2.25v11.5A2.25 2.25 0 006.249 20h11.5A2.25 2.25 0 0020 17.75v-6.958H20z"
    />
    <path
      fill="currentColor"
      d="M18.5 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
      opacity=".3"
    />
  </svg>
);

export const BigPlus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" fill="none">
    <g filter="url(#filter0_d)" opacity=".16">
      <rect width="112" height="112" x="8" y="6" fill="#2154EB" rx="56" />
    </g>
    <path
      fill="#2154EB"
      d="M61.353 64.719H53a1 1 0 01-1-1v-3.293a1 1 0 011-1h8.353V51a1 1 0 011-1h3.294a1 1 0 011 1v8.426H75a1 1 0 011 1v3.293a1 1 0 01-1 1h-8.353v8.305a1 1 0 01-1 1h-3.294a1 1 0 01-1-1V64.72z"
    />
    <defs>
      <filter
        id="filter0_d"
        width="128"
        height="128"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix values="0 0 0 0 0.3528 0 0 0 0 0.78316 0 0 0 0 0.84 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const PinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.055 20.134C9.143 18.313 5 13.962 5 10.5 5 6 7.8 3 12 3s7 3 7 7.5c0 3.462-4.143 7.812-6.055 9.634-.535.511-1.355.511-1.89 0zM15 10a3 3 0 11-6 0 3 3 0 016 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect
      width="18"
      height="18"
      x="3"
      y="3"
      fill="currentColor"
      opacity=".3"
      rx="1.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.91 12h8.18c.503 0 .91.448.91 1s-.407 1-.91 1H7.91c-.503 0-.91-.448-.91-1s.407-1 .91-1zm1.817 4h4.546c.502 0 .909.448.909 1s-.407 1-.91 1H9.728c-.502 0-.909-.448-.909-1s.407-1 .91-1z"
      clipRule="evenodd"
      opacity=".3"
    />
    <path
      fill="currentColor"
      d="M3 4.5A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5V9H3V4.5z"
    />
    <rect
      width="3"
      height="5"
      x="6.5"
      y=".5"
      fill="currentColor"
      stroke="#fff"
      rx="1.5"
    />
    <rect
      width="3"
      height="5"
      x="14.5"
      y=".5"
      fill="currentColor"
      stroke="#fff"
      rx="1.5"
    />
  </svg>
);
